<template>
  <main class="staff-page embed-page">
    <property-detail-content
      v-if="propertyId"
      :property-id="propertyId"
      :highlighted-contact-id="highlightedContactId"
    />
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import PropertyDetailContent from '@/components/PropertyDetailContent.vue';

const route = useRoute();
const propertyId = ref<number | null>(null);
const highlightedContactId = ref<number | null>(null);

onMounted(() => {
  const id = route.params.id;
  if (id) {
    propertyId.value = Number(id);
  }

  const contactIdParam = route.query.contactId;
  if (contactIdParam) {
    highlightedContactId.value = parseInt(contactIdParam as string, 10);
  }
});
</script>
